export default {
	default: [''],
	primary: ['hyperlink--bg-brand-1'],
	secondary: ['hyperlink--bg-brand-2'],
	secondaryTint: ['hyperlink--bg-brand-2-tint']
};
